import { useQuery } from "convex/react";
import { useSessionAction, useSessionMutation } from './useSession';
import { api } from "../convex/_generated/api";

/**
 * AI Hook - Convex Edition
 *
 * Custom hook az AI funkciókhoz Convex-szel.
 * OpenRouter migráció: useOpenRouterModels hook hozzáadva.
 */

// Plant Analysis hooks
// Megjegyzés: a plantAnalysis exportok `: any` típusúak (körkörös típus-
// hivatkozás feloldása), ezért a generált api típusból kiesnek — cast kell.
export const usePlantAnalysis = () => {
  const analyzePlantHealth = useSessionAction(
    (api.ai as any).plantAnalysis.analyzePlantHealth
  );
  const identifyPlant = useSessionAction((api.ai as any).plantAnalysis.identifyPlant);
  const generatePlantRecommendations = useSessionAction(
    (api.ai as any).plantAnalysis.generatePlantRecommendations
  );
  const generateCareTips = useSessionAction(
    (api.ai as any).plantAnalysis.generateCareTips
  );
  const chatAboutAnalysis = useSessionAction(
    (api.ai as any).plantAnalysis.chatAboutAnalysis
  );

  return {
    analyzePlantHealth,
    identifyPlant,
    generatePlantRecommendations,
    generateCareTips,
    chatAboutAnalysis,
  };
};

/**
 * Fotó alapú kerttervezés hook.
 * Egy kertfotóból + a megadott valódi méretekből készít szerkeszthető
 * kertterv-objektumokat (lásd convex/ai/gardenPhotoPlan.ts).
 */
export const useGardenPhotoPlan = () => {
  const analyzeGardenPhoto = useSessionAction(
    (api.ai as any).gardenPhotoPlan.analyzeGardenPhoto
  );

  return { analyzeGardenPhoto };
};

// Image Generation hooks
export const useImageGeneration = () => {
  const generatePlantImage = useSessionAction(
    (api.ai as any).imageGeneration.generatePlantImage
  );
  const generateGardenPreview = useSessionAction(
    (api.ai as any).imageGeneration.generateGardenPreview
  );
  const generatePlantTopView = useSessionAction(
    (api.ai as any).imageGeneration.generatePlantTopView
  );
  const generateSeasonalVariation = useSessionAction(
    (api.ai as any).imageGeneration.generateSeasonalVariation
  );

  return {
    generatePlantImage,
    generateGardenPreview,
    generatePlantTopView,
    generateSeasonalVariation,
  };
};

// AI Settings hooks (admin only)
export const useAISettings = () => {
  const settings = useQuery(api.aiSettings.get);
  const upsertSettings = useSessionMutation(api.aiSettings.upsert);
  const updateApiKey = useSessionMutation(api.aiSettings.updateApiKey);

  return {
    settings,
    isLoading: settings === undefined,
    upsertSettings,
    updateApiKey,
  };
};

// OpenRouter Models hooks
export const useOpenRouterModels = () => {
  const cached = useQuery(api.ai.openrouterModelsQueries.getCachedModels);
  const fetchModels = useSessionAction(api.ai.openrouterModels.fetchModels);

  return {
    models: cached?.models ? JSON.parse(cached.models) : [],
    isLoading: cached === undefined,
    isEmpty: cached === null,
    fetchedAt: cached?.fetchedAt,
    totalCount: cached?.totalCount ?? 0,
    refreshModels: fetchModels,
  };
};
